"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationDocument = void 0;
const common_1 = require("../../common");
const product_implementation_common_document_model_1 = require("./product-implementation-common-document.model");
const product_implementation_model_1 = require("./product-implementation.model");
class ProductImplementationDocument extends common_1.MongoDocument {
}
exports.ProductImplementationDocument = ProductImplementationDocument;
//# sourceMappingURL=product-implementation-document.model.js.map